// Context for managing alert modals
import React, { createContext, useContext, useState } from 'react';
import AlertModal from '../components/AlertModal';
import { getCreativeError } from '../utils/errorMessages';

const AlertContext = createContext();

export const useAlert = () => {
    const context = useContext(AlertContext);
    if (!context) {
        throw new Error('useAlert must be used within AlertProvider');
    }
    return context;
};

export const AlertProvider = ({ children }) => {
    const [alert, setAlert] = useState(null);

    const showAlert = (title, message, type = 'info', buttonText = 'OK') => {
        setAlert({ title, message, type, buttonText });
    };

    const closeAlert = () => {
        setAlert(null);
    };

    // Convenience methods — network errors get creative anime-themed messages
    const showError = (message, title = 'Error') => {
        showAlert(title, getCreativeError(message), 'error', 'OK');
    };

    const showWarning = (message, title = 'Warning') => {
        showAlert(title, message, 'warning', 'OK');
    };

    const showSuccess = (message, title = 'Success') => {
        showAlert(title, message, 'success', 'OK');
    };

    const showInfo = (message, title = 'Information') => {
        showAlert(title, message, 'info', 'OK');
    };

    return (
        <AlertContext.Provider value={{ showAlert, showError, showWarning, showSuccess, showInfo, closeAlert }}>
            {children}
            <AlertModal
                isOpen={!!alert}
                onClose={closeAlert}
                title={alert?.title || ''}
                message={alert?.message || ''}
                type={alert?.type || 'info'}
                buttonText={alert?.buttonText || 'OK'}
            />
        </AlertContext.Provider>
    );
};
